import styled from 'styled-components';

import { SCREEN_WIDTH_BREAKPOINTS } from 'core/constants';

export const Item = styled.div<{ $active: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 2px 6px;
  padding: 12px;

  border-radius: ${({ $active }) => ($active ? '4px' : '')};
  background: ${({ $active }) => ($active ? 'rgba(255, 255, 255, 0.08)' : '')};

  &:hover {
    svg {
      path {
        fill-opacity: 1;
      }
    }

    border-radius: 4px;
    background: rgba(255, 255, 255, 0.08);
  }

  @media (max-width: ${SCREEN_WIDTH_BREAKPOINTS.SMALL_SCREEN}px) {
    padding: 8px;
  }
`;

export const IconContainer = styled.div`
  width: 20px;
  height: 20px;

  @media (max-width: ${SCREEN_WIDTH_BREAKPOINTS.SMALL_SCREEN}px) {
    width: 16px;
    height: 16px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;
